export const POST_TELEHEALTH_REQUEST = 'POST_TELEHEALTH_REQUEST';
export const POST_TELEHEALTH_SUCCESS = 'POST_TELEHEALTH_SUCCESS';
export const POST_TELEHEALTH_ERROR = 'POST_TELEHEALTH_ERROR';